// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
h1 {
  margin: 0;
}
html,
body {
  height: 100%;
  font-family: Microsoft YaHei;
}
#app {
  overflow-x: hidden;
}
svg,
path {
  fill: currentColor;
}
.ant-table-fixed {
  table-layout: fixed;
}
.ant-table-tbody > tr > td {
  word-wrap: break-word;
  word-break: break-all;
}
`, "",{"version":3,"sources":["webpack://./app/assets/styles/common.less"],"names":[],"mappings":"AAKA;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AAJF;AAOA;EACE,SAAA;AALF;AAOA;;EAEE,YAAA;EAEA,4BAAA;AANF;AAQA;EACE,kBAAA;AANF;AASA;;EAEE,kBAAA;AAPF;AASA;EACE,mBAAA;AAPF;AAUA;EACE,qBAAA;EACA,qBAAA;AARF","sourcesContent":[".wrapper {\n  // width: 1200px;\n  // margin: 0 auto;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nh1 {\n  margin: 0;\n}\nhtml,\nbody {\n  height: 100%;\n  // background-color: #f0f2f5;\n  font-family: Microsoft YaHei;\n}\n#app {\n  overflow-x: hidden;\n}\n\nsvg,\npath {\n  fill: currentColor;\n}\n.ant-table-fixed {\n  table-layout: fixed;\n}\n\n.ant-table-tbody > tr > td {\n  word-wrap: break-word;\n  word-break: break-all;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
